import {
  Alert,
  Button,
  Grid,
  Hidden,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import api from "../../../app/api";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import Loader from "../../common/Loader";

const HOWVALUES = [
  "Legal Consultation",
  "Job/ Internship",
  "Join you initiative",
];

const courts = [
  "Supreme Court",
  "High Court",
  "District &amp; Sessions Court",
  "National Consumer Disputes Redressal Commission (NCDRC)",
  "Central Administrative Tribunal (CAT)",
  "National Green Tribunal (NGT)",
  "Armed Forces Tribunal (AFT)",
  "Other",
];

const SUBHOWVALUES = [
  "Criminal matter – Crime against a person",
  "Criminal matter – Crime against property",
  "FIR",
  "Bail",
  "Anticipatory bail",
  "POCSO / Child Abuse",
  "Crime against women",
  "LGBTQIA related issue",
  "Cyber crime",
  "Workplace related issue",
  "Employment – Non-Government",
  "Service Matter",
  "Divorce",
  "Domestic Violence",
  "Maintenance",
  "Family Dispute",
  "Child Custody",
  "Muslim Law",
  "Medical Negligence",
  "Trademark, Copyright, Patent",
  "Customs &amp; Central Excise",
  "Corporate / Startup",
  "Tax",
  "Consumer Court",
  "Cheque Bounce",
  "Recovery",
];

const defaultForm = {
  name: "",
  email: "",
  mobile: "",
  how: HOWVALUES[0],
  msg: "",
  court: "",
  subhow: "",
};
const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
    paddingBottom: SIDE_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    backgroundColor: theme.palette.primary.light,
  },
  formimg: {
    // width: "100%",
    height: "100%",
  },
  main: {
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 5,
    overflow: "hidden",

    borderColor: theme.palette.secondary.main,
    padding: 0,
    [theme.breakpoints.down("md")]: {
      borderWidth: 0,
    },
  },
  formlabel: {
    fontSize: 12,
    fontWeight: "bold",
  },
  txtfieldfull: {
    width: "100%",
  },
  fieldWrapper: {
    paddingTop: "5%",
  },
  fieldWrapperButton: {
    paddingTop: "5%",
    paddingBottom: "5%",
  },
  sendBtn: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

const Form = (props) => {
  const classes = usestyles();
  const [form, setForm] = useState(defaultForm);
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name) {
      if (name === "how") {
        if (value === HOWVALUES[0]) {
          setForm({ ...form, [name]: value });
        } else {
          setForm({ ...form, [name]: value, subhow: "", court: "" });
        }
      } else {
        setForm((prev) => ({ ...prev, [name]: value }));
      }
    }
  };

  const submitFormHandler = async () => {
    try {
      setLoader(true);
      await api.withoutAuth.post("forms", form);
      setMessage("Sumitted Successfully");
      setForm(defaultForm);
      setTimeout(() => {
        setMessage("");
      }, 6000);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className={classes.root}>
      <Loader open={loader} />
      <Snackbar
        open={Boolean(message)}
        autoHideDuration={6000}
        // onClose={errorConfirmedHandler}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success">{message}</Alert>
      </Snackbar>
      <Grid container className={classes.main} justifyContent="space-between">
        <Hidden mdDown>
          <Grid
            xs={6}
            item
            style={{
              overFlow: "hidden",
            }}
          >
            <img
              alt="form"
              src="/images/query.svg"
              className={classes.formimg}
            />
          </Grid>
        </Hidden>
        <Grid
          xs={12}
          md={6}
          item
          style={{ paddingRight: "2%", paddingLeft: "4%" }}
        >
          <Hidden mdUp>
            <Typography
              style={{
                textAlign: "center",
              }}
            >
              Got a query? Write to us.
            </Typography>
          </Hidden>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitFormHandler();
            }}
          >
            <Grid container justifyContent={"space-between"}>
              <Grid xs={12} item className={classes.fieldWrapper}>
                <Typography className={classes.formlabel}>NAME*</Typography>
                <TextField
                  variant="outlined"
                  color="secondary"
                  className={classes.txtfieldfull}
                  size="small"
                  placeholder="Your name"
                  required
                  type={"text"}
                  name={"name"}
                  onChange={handleChange}
                  value={form.name}
                />
              </Grid>
              <Grid xs={12} md={5} item className={classes.fieldWrapper}>
                <Typography className={classes.formlabel}>
                  EMAIL ADDRESS*
                </Typography>
                <TextField
                  variant="outlined"
                  color="secondary"
                  className={classes.txtfieldfull}
                  size="small"
                  placeholder="abc@gmail.com"
                  required
                  type={"email"}
                  name={"email"}
                  onChange={handleChange}
                  value={form.email}
                />
              </Grid>
              <Grid xs={12} md={6} item className={classes.fieldWrapper}>
                <Typography className={classes.formlabel}>
                  MOBILE NUMBER*
                </Typography>

                <Grid container justifyContent={"space-between"}>
                  <Grid item xs={3}>
                    <TextField
                      variant="outlined"
                      color="secondary"
                      //className={classes.txtfieldfull}
                      size="small"
                      placeholder="+91"
                      type={"text"}
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={7} md={8}>
                    <TextField
                      variant="outlined"
                      color="secondary"
                      //className={classes.txtfieldfull}
                      size="small"
                      placeholder="XXX XXX XXXX"
                      required
                      type={"tel"}
                      name={"mobile"}
                      onChange={handleChange}
                      value={form.mobile}
                      inputProps={{
                        maxLength: 10,
                        minLength: 10,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={5} item className={classes.fieldWrapper}>
                <Typography className={classes.formlabel}>
                  HOW CAN I HELP YOU
                </Typography>
                <Select
                  color="secondary"
                  className={classes.txtfieldfull}
                  size="small"
                  name={"how"}
                  value={form.how}
                  onChange={handleChange}
                  required
                >
                  {HOWVALUES.map((value) => {
                    return (
                      <MenuItem value={value} key={value}>
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Grid>
              {form.how === HOWVALUES[0] && (
                <Grid xs={6} item className={classes.fieldWrapper}>
                  <Typography className={classes.formlabel}>COURT</Typography>
                  <Select
                    color="secondary"
                    className={classes.txtfieldfull}
                    size="small"
                    name={"court"}
                    value={form.court}
                    onChange={handleChange}
                    required
                  >
                    {courts.map((value) => {
                      return (
                        <MenuItem
                          value={value}
                          selected={value === form.court}
                          key={value}
                        >
                          {value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
              )}
              {form.how === HOWVALUES[0] && (
                <Grid xs={12} item className={classes.fieldWrapper}>
                  <Typography className={classes.formlabel}>DETAILS</Typography>
                  <Select
                    color="secondary"
                    className={classes.txtfieldfull}
                    size="small"
                    name={"subhow"}
                    value={form.subhow}
                    onChange={handleChange}
                    required
                  >
                    {SUBHOWVALUES.map((value) => {
                      return (
                        <MenuItem
                          value={value}
                          selected={value === form.court}
                          key={value}
                        >
                          {value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </Grid>
              )}

              <Grid xs={12} item className={classes.fieldWrapper}>
                <Typography className={classes.formlabel}>
                  YOUR MESSAGE
                </Typography>
                <TextField
                  color="secondary"
                  className={classes.txtfieldfull}
                  size="small"
                  name={"msg"}
                  value={form.msg}
                  onChange={handleChange}
                  required
                  multiline
                  placeholder="Type here..."
                  inputProps={{
                    style: {
                      height: 100,
                    },
                    maxLength: 250,
                  }}
                />
              </Grid>

              <Grid
                xs={12}
                item
                className={classes.fieldWrapperButton}
                container
                justifyContent={"flex-end"}
              >
                <Button type={"submit"} className={classes.sendBtn}>
                  Send Message
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Form;
